import React from 'react';

const SpotAttendeeInfo = ({attendee}) => {
  const { avatar, firstName, lastName, vehicleNumber } = attendee;
  return (
    <div className="media profile">
      { avatar ? <img src={avatar} className="pull-left" /> : <div className="icon-profile-empty-30 pull-left"/>}
      <div className="media-body">
        <strong>{firstName} {lastName}</strong>
        {vehicleNumber ? `#${vehicleNumber}` : '' } {attendee.class}
      </div>
    </div>
  );
};

export default SpotAttendeeInfo;



// WEBPACK FOOTER //
// ./src/components/MapInfoBar/ParkingSpotInfoDetail/SpotAttendeeInfo.js